import { petNameElements } from '@flows/configs/petHealthV2/steps/elements/petName'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'

const pet_name = (params: StepConfigParams) =>
  fragmentStep(petNameElements(params), params, 'pet_type')

export default pet_name
